<template>
  <div id="wrapper">
    <b-container id="UniqueFeedback">
      <b-row>
        <b-col sm="12" md="6" class="d-flex align-items-center">
          <img class="img-fluid unique-feedback-img" src="/img/home/tm_uniquefeedback.png" />
        </b-col>
        <b-col sm="12" md="6" class="d-flex align-items-center">
          <h3 class="text-md-right">
            <b>TorchMetrics’</b> unique feedback and coaching platform is based on
            25+ years of presentation training and coaching with executives
            and leaders from Fortune 500 companies and global nonprofits.
          </h3>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="learn-more">
          <TMGeneralButton
            text="LEARN MORE"
            route="HowItWorks"
            className="blue"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import TMGeneralButton from "@/components/common/TMGeneralButton";
export default {
  name: "UniqueFeedback",
  components: {
    TMGeneralButton,
  },
}
</script>
<style lang="less" scoped>
@import "../../assets/components/home/UniqueFeedback.less";
</style>